import React from 'react';
import UniversalIconBtn from '../headless/button/UniversalIconBtn';
import { useEditMode } from '../../hooks/useEditMode';
import { StyledDivComponent, StyledInputComponent } from '../../dto/StyleCompRepository';
import { OrgWrapper } from './OrgDescription';
import HeadlessInput from '../headless/input/HeadlessInput';
import styled from 'styled-components';
import searchIcon from '../../../asset/icon/see.png';
import searchNotIcon from '../../../asset/icon/see_not.png';
import { useDeviceStore } from '../../store/deviceStore';
import { DeviceType } from '../../enum/EnumRepository';
import HintSmallWrapper from '../headless/button/HintSmallWrapper';
import { getHintMessage } from '../../constants/hintMessages';

interface OrgInputDivVisiProps {
  value: string | number;
  defaultValue: string;
  placeholder: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputStyle: StyledInputComponent;
  StyledDiv: StyledDivComponent;
  DefaultDiv: StyledDivComponent;
  visible: boolean;
  changeVisible: () => void;
  changeVisibleMobile?: () => void;
  minLimit?: number;
  maxLimit?: number;
}

const OrgInputDivVisi: React.FC<OrgInputDivVisiProps> = ({
  value,
  defaultValue,
  placeholder,
  handleChange,
  inputStyle,
  StyledDiv,
  DefaultDiv,
  visible,
  changeVisibleMobile,
  changeVisible,
  minLimit,
  maxLimit,
}) => {
  const { isEditMode } = useEditMode();
  const { deviceType } = useDeviceStore();
  return (
    <>
      {isEditMode ? (
        <OrgWrapper>
          <InputWrapper $isVisible={visible}>
            <HeadlessInput
              type={'text'}
              value={value}
              handleChange={handleChange}
              placeholder={placeholder}
              StyledInput={inputStyle}
              minLimit={minLimit}
              maxLimit={maxLimit}
            />
          </InputWrapper>
          <HintSmallWrapper content={visible ? getHintMessage('SET_TO_PRIVATE') : getHintMessage('SET_TO_PUBLIC')} toLeft={true}>
            <UniversalIconBtn
              size="fit"
              border={false}
              isTransparent
              backgroundImg={visible ? searchIcon : searchNotIcon}
              onClick={deviceType === DeviceType.MOBILE ? changeVisibleMobile : changeVisible}
            />
          </HintSmallWrapper>
        </OrgWrapper>
      ) : (
        visible ? (
          value ? (
            <StyledDiv>{value}</StyledDiv>
          ) : (
            <DefaultDiv>{defaultValue}</DefaultDiv>
          )
        ) : null
      )}
    </>
  );
};

const InputWrapper = styled.div<{ $isVisible: boolean }>`
  width: 100%;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0.5)};
`;

export default OrgInputDivVisi;
